/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Payments_Subscriptions_EmptyInputs */

const en_my_payments_subscriptions_empty = /** @type {(inputs: My_Payments_Subscriptions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No subscriptions.`)
};

const pl_my_payments_subscriptions_empty = /** @type {(inputs: My_Payments_Subscriptions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak subskrypcji.`)
};

/**
* | output |
* | --- |
* | "No subscriptions." |
*
* @param {My_Payments_Subscriptions_EmptyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const my_payments_subscriptions_empty = /** @type {((inputs?: My_Payments_Subscriptions_EmptyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Payments_Subscriptions_EmptyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_my_payments_subscriptions_empty(inputs)
	return en_my_payments_subscriptions_empty(inputs)
});